// @flow
import type { AxiosInstance, AxiosPromise } from "axios";
import type { UserTransformer } from "../types";

const logout = (): ((
  apiInstance: AxiosInstance
) => AxiosPromise<UserTransformer>) => (apiInstance) =>
  apiInstance.post("/v5/auth/logout");

export default logout;
